/* tslint:disable */
/* eslint-disable */
/**
 * Stotles Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LinkEditItem
 */
export interface LinkEditItem {
    /**
     * 
     * @type {string}
     * @memberof LinkEditItem
     */
    url: string;
    /**
     * 
     * @type {string}
     * @memberof LinkEditItem
     */
    caption?: string;
    /**
     * 
     * @type {string}
     * @memberof LinkEditItem
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof LinkEditItem
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof LinkEditItem
     */
    srcUrl?: string;
}

/**
 * Check if a given object implements the LinkEditItem interface.
 */
export function instanceOfLinkEditItem(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "url" in value;

    return isInstance;
}

export function LinkEditItemFromJSON(json: any): LinkEditItem {
    return LinkEditItemFromJSONTyped(json, false);
}

export function LinkEditItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): LinkEditItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'url': json['url'],
        'caption': !exists(json, 'caption') ? undefined : json['caption'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'srcUrl': !exists(json, 'src_url') ? undefined : json['src_url'],
    };
}

export function LinkEditItemToJSON(value?: LinkEditItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'url': value.url,
        'caption': value.caption,
        'title': value.title,
        'description': value.description,
        'src_url': value.srcUrl,
    };
}

